import React, { useContext, useRef } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import globalContext from "../../Contexts/GlobalContext";

export default function ExitConformation() {
  const [cookies, setCookies, removeCookies] = useCookies();
  const navigate = useNavigate();
  const contextData = useContext(globalContext);
  const testRef = useRef();
  const exitUser = () => {
    for (const item in cookies) {
      if (item !== "slider") {
        removeCookies(item);
      }
    }
    navigate("/login");
    contextData.setIsExitModalOpen(false);
  };
  setTimeout(() => {
    testRef?.current?.classList?.add("backdrop-blur-sm");
  }, 300);
  return (
    <div
      ref={testRef}
      className="absolute w-full h-screen  flex items-center justify-center z-[1000] "
      onClick={() => {
        contextData.setIsExitModalOpen(false);
      }}
    >
      <div
        className="relative w-[80vw] pb-[3vw] bg-[#001D26] border-color-primary-D  flex flex-col items-center justify-evenly border-[1px] z-[800] rounded-[1vw] "
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className="w-full flex items-center justify-center bg-color-primary-D font-font_primary_A text-[#153038]">
          <span className="py-[2vw] font-bold">خروج از حساب</span>
        </div>

        <span
          className={`w-full text-right flex items-center justify-start text-[3vw] z-[800] text-color-primary-C font-font_primary_A mt-[3.7vw] px-[4vw]`}
        >
          آیا می‌خواهید از حساب کاربری خود خارج شوید؟
        </span>

        <div className="flex items-center justify-between gap-x-[3vw] mt-[3.7vw]">
          <button
            className="relative w-[30vw] h-[9vw]  rounded-[1vw] text-center flex items-center justify-center text-[#AF3434] font-font_primary_A text-[4vw] bg-[#001D26] z-[1000]"
            onClick={() => {
              contextData.setIsExitModalOpen(false);
            }}
          >
            خیر
          </button>
          <button
            className="relative w-[30vw] h-[9vw] rounded-[1vw] text-center flex items-center justify-center text-[#F8F8F3] font-font_primary_A text-[4vw] bg-[#153038] z-[1000]"
            onClick={exitUser}
          >
            بله
          </button>
        </div>
      </div>
    </div>
  );
}
